import axios from 'axios';
import Store from '@/store/index.js'

const api = axios.create({
    baseURL: process.env.VUE_APP_API_URL+'frontlsa',
})
let refreshing = false

api.interceptors.request.use(async function (config) {
    if (Store.getters.isAuthenticated() && Store.getters.getTokenValidityRemaining() <= 0) {
      sessionStorage.clear()
      location.reload()
    }
    if (Store.getters.isAuthenticated() && Store.getters.getTokenValidityRemaining() > 0 && Store.getters.getTokenValidityRemaining() < 1800 && refreshing == false) {
      if (Store.getters.isRefreshTokenValid()) {
        refreshing = true
        await Store.dispatch('auth_refresh_token')
        .then(() => {})
        .catch(() => Store.dispatch('auth_logout'))
      }
      else {
        Store.dispatch('auth_logout')
      }
      refreshing = false
    }
    return config;
}, function (error) {
    return Promise.reject(error);
});

export default api;